import React from 'react';

const InventorySidebar = ({facets}) => {
    return <div className='sideBar'>
        <ul className='categories'>
            {facets.map((category) =>{
                return <li className='categoryName' key={`${category.name}`}>
                    <div>{category.name}</div>
                    <ul className='categoryItems'>
                        {category.facets.map((facet) => {
                            return <li key={facet.name}><a href={`/sales/inventory/${facet.seoNormalizedName}`}>{`${facet.name} (${facet.count})`}</a></li>
                        })}
                    </ul>
                </li>                
            })}
        </ul>
    </div>
}

export default InventorySidebar;